export default __webpack_public_path__ + "static/media/Group 3406_blue.3f28bdf4.png";